"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      save_plan: [],
      defaultAd: {
        depend_type: []
      }
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('wxapi/store/outer_banners', {
        store_id: this.id,
        depend_type: -1
      }).then(function (res) {
        _this.save_plan = res.banner_list;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var params = {};
      params.save_plan = this.save_plan;
      params.store_id = this.id;
      this.$post('agentapi/store/save_outer_banners', params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    }
  }
};